import React, { createContext, useCallback, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
const HomePageContext = createContext();

export const HomeProvider = ({ children }) => {
  const id = localStorage.getItem("id") && localStorage.getItem("id");
  const token = localStorage.getItem("token") && localStorage.getItem("token");
  const userInfo = "https://proxy-api.cyxym.net/app/v1?account";
  const activePay = "https://proxy-api.cyxym.net/app/v1?pay.temp";
  const blockUrl = "https://proxy-api.cyxym.net/app/v1?account.lock";
  const connectionInfo = "https://proxy-api.cyxym.net/app/v1?account.link";
  const getMsg = "https://proxy-api.cyxym.net/app/v1?chat";
  const intercom = "https://proxy-api.cyxym.net/app/v3?intercom.list";

  const [info, setInfo] = useState([]);
  const [connInfo, setConnInfo] = useState([]);
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [fullName, setFullName] = useState("");
  const [messages, setMessages] = useState([]);
  const [tempPay, setTempPay] = useState(false);
  const [update, setUpdate] = useState(false);
  const [isLocked, setIsLocked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sending, setSending] = useState(false);
  const [intercomData, setIntercomData] = useState([]);
  const [openingDoor, setOpeningDoor] = useState(null);

  const [intercomLoading, setIntercomLoading] = useState(false);
  const [doorStatus, setDoorStatus] = useState({});
  const [toast, setToast] = useState({
    open: false,
    severity: "error",
    message: ""
  });

  const location = useLocation();

  const navigate = useNavigate();

  const blockUser = async () => {
    setLoading(true);
    const body = new FormData();
    body.append("id", id);
    body.append("token", token);
    body.append("lock", isLocked ? 0 : 1);

    const response = await fetch(blockUrl, {
      method: "POST",
      body: body
    });
    const data = await response.json();

    if (data.response.status || !data.response.status) {
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
  };

  const activeTempPay = async () => {
    setLoading(true);
    const body = new FormData();
    body.append("id", id);
    body.append("token", token);
    const response = await fetch(activePay, {
      method: "POST",
      body: body
    });
    const data = await response.json();
    if (data.response.status) {
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
  };

  useEffect(() => {
    if (location.pathname !== "/") return;
    const controller = new AbortController();

    const getConnectionInfo = async () => {
      const body = new FormData();
      body.append("id", id);
      body.append("token", token);

      const response = await fetch(connectionInfo, {
        method: "POST",
        body: body,
        signal: controller.signal
      });

      const data = await response.json();
      setConnInfo(data?.response?.data);
    };

    const getData = async () => {
      setLoading(true);
      const body = new FormData();
      body.append("id", id);
      body.append("token", token);
      const response = await fetch(userInfo, {
        method: "POST",
        body: body,
        signal: controller.signal
      });

      const data = await response.json();
      if (data.response.status) {
        setInfo(data?.response?.data);
        setFirstName(data?.response?.data?.firstname?.charAt(0));
        setMiddleName(data?.response?.data?.middlename?.charAt(0));
        setFullName(data?.response?.data?.fullname);
        setTempPay(data?.response?.data?.temp_pay_allowed);
        setIsLocked(data?.response?.data?.is_locked);
        localStorage.setItem("new_psw", data?.response?.data?.password_changed);

        try {
          const flag = data?.response?.data?.chat_enabled ? "ok1" : "no0"; // любое непонятное значение
          const obf = btoa(flag); // base64 кодируем
          localStorage.setItem("cf", obf);
        } catch (err) {
          console.error("Ошибка при сохранении chat flag:", err);
        }

        setLoading(false);
      } else {
        localStorage.clear();
        navigate("/login");
      }
    };

    const getIntercom = async () => {
      try {
        setIntercomLoading(true);

        const body = new FormData();

        body.append("token", token);

        const response = await fetch(intercom, {
          method: "POST",
          body,
          signal: controller.signal
        });

        const data = await response.json();

        setIntercomData(data?.response?.data || []);
      } catch (error) {
        if (error.name !== "AbortError") {
          console.error("Ошибка загрузки домофонов", error);
        }
      } finally {
        setIntercomLoading(false);
      }
    };

    getData();
    getConnectionInfo();
    getIntercom();

    return () => {
      controller.abort();
      setUpdate(false);
    };
  }, [update, id, navigate, token, location.pathname]);

  const openDoor = async domophone => {
    if (openingDoor) return;

    const id = domophone.domophoneId;

    try {
      setOpeningDoor(id);

      const body = new FormData();

      body.append("token", token);
      body.append("domophoneId", id);
      body.append("doorId", domophone.doorId);

      const response = await fetch(
        "https://proxy-api.cyxym.net/app/v3?intercom.open",
        {
          method: "POST",
          body
        }
      );

      const data = await response.json();

      const success = data?.response?.status;

      setDoorStatus(prev => ({
        ...prev,
        [id]: success ? "success" : "error"
      }));

      if (!success) {
        setToast({
          open: true,
          severity: "error",
          message: data?.response?.message || "Не удалось открыть дверь"
        });
      }
    } catch (error) {
      setDoorStatus(prev => ({
        ...prev,
        [id]: "error"
      }));

      setToast({
        open: true,
        severity: "error",
        message: "Ошибка соединения с сервером"
      });

      console.error("Ошибка открытия двери", error);
    } finally {
      setOpeningDoor(null);

      setTimeout(() => {
        setDoorStatus(prev => ({
          ...prev,
          [id]: null
        }));
      }, 2000);
    }
  };

  const getMessages = useCallback(async () => {
    try {
      const body = new FormData();
      body.append("token", token);

      const response = await fetch(getMsg, {
        method: "POST",
        body
      });

      const data = await response.json();

      if (data.response.status) {
        setMessages(prev => {
          const newMessages = data.response.messages || [];

          // если ничего не изменилось — не ререндерим
          if (
            prev.length === newMessages.length &&
            prev[prev.length - 1]?.id ===
              newMessages[newMessages.length - 1]?.id
          ) {
            return prev;
          }

          return newMessages;
        });
      }
    } catch (err) {
      if (err.name !== "AbortError") {
        console.error(err);
      }
    }
  }, [token]);

  // useEffect(() => {
  //   const controller = new AbortController();

  //   getMessages(controller.signal);

  //   const interval = setInterval(() => {
  //     getMessages(controller.signal);
  //   }, 10000);

  //   return () => {
  //     controller.abort();
  //     clearInterval(interval);
  //   };
  // }, [getMessages]);

  return (
    <HomePageContext.Provider
      value={{
        info,
        firstName,
        middleName,
        tempPay,
        setUpdate,
        activeTempPay,
        isLocked,
        blockUser,
        loading,
        fullName,
        setIsLocked,
        connInfo,
        messages,
        getMessages,
        sending,
        setSending,
        intercomData,
        openingDoor,
        openDoor,
        intercomLoading,
        doorStatus,
        toast,
        setToast
      }}
    >
      {children}
    </HomePageContext.Provider>
  );
};

export default HomePageContext;
